import { render, staticRenderFns } from "./NewAnnouncementContainer.vue?vue&type=template&id=aa7be79e"
import script from "./NewAnnouncementContainer.vue?vue&type=script&lang=js"
export * from "./NewAnnouncementContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports